import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Button from "./Button";

// Dark-themed confirmation shown after a file finishes uploading.
export default function UploadSuccessModal({ isOpen, onClose, downloadUrl }) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/60 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl border border-white/10 bg-navy-700 p-6 text-left align-middle shadow-card transition-all">
                <Dialog.Title
                  as="h3"
                  className="font-display text-lg font-semibold text-white"
                >
                  File uploaded
                </Dialog.Title>
                <div className="mt-2">
                  <p className="text-sm leading-relaxed text-white/60">
                    Your file is uploaded and processing. You'll get an email
                    when it's ready to download.
                  </p>
                  {downloadUrl && (
                    <p className="mt-3 break-words text-xs text-white/40">
                      {downloadUrl}
                    </p>
                  )}
                </div>

                <div className="mt-5">
                  <Button variant="primary" onClick={onClose}>
                    Got it, thanks!
                  </Button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
